<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowGrossHaRevPerGrossRev',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth, offset) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'gross_ha_revenue', throughMonth, offset),
          this.getYtdByField(yearObj, 'gross_revenue', throughMonth, offset),
        );
      },
    },
  };
</script>
